<template>
  <div>
    <v-row class="mb-4">
      <v-col>
        <h3 class="text-h6 font-weight-medium mb-4">
          Profile Information
        </h3>
        <p class="text--secondary">
          Update your personal information and contact details.
        </p>
      </v-col>
    </v-row>

    <v-form
      ref="profileForm"
      v-model="valid"
      @submit.prevent="handleSubmit"
    >
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model="localProfile.firstName"
            label="First Name"
            outlined
            :rules="nameRules"
            required
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model="localProfile.lastName"
            label="Last Name"
            outlined
            :rules="nameRules"
            required
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model="localProfile.email"
            label="Email Address"
            outlined
            :rules="emailRules"
            required
            type="email"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model="localProfile.phone"
            label="Phone Number"
            outlined
            :rules="phoneRules"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model="localProfile.title"
            label="Job Title"
            outlined
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model="localProfile.department"
            label="Department"
            outlined
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col class="d-flex justify-end">
          <v-btn
            color="primary"
            :disabled="!valid || !hasChanges"
            :loading="loading"
            @click="handleSubmit"
          >
            Update Profile
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
export default {
  name: 'SettingsProfile',
  props: {
    profile: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valid: false,
      localProfile: {},
      nameRules: [
        (v) => !!v || 'Name is required',
        (v) => (v && v.length >= 2) || 'Name must be at least 2 characters',
        (v) => (v && v.length <= 50) || 'Name must be less than 50 characters',
      ],
      emailRules: [
        (v) => !!v || 'Email is required',
        (v) => /.+@.+\..+/.test(v) || 'Email must be valid',
      ],
      phoneRules: [
        (v) => !v || /^[\d\s\-()+]+$/.test(v) || 'Phone number must be valid',
      ],
    }
  },
  computed: {
    hasChanges() {
      return JSON.stringify(this.localProfile) !== JSON.stringify(this.profile)
    },
  },
  watch: {
    profile: {
      handler(newProfile) {
        this.localProfile = { ...newProfile }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleSubmit() {
      if (this.valid && this.hasChanges) {
        this.$emit('update', this.localProfile)
      }
    },
  },
}
</script>
